<template>
    <article v-if="item !== null" class="tabs-module" :class="getModuleThemeClass()">
        <h2 v-if="item.Headline != ''" class="tabs-module__headline">{{ item.Headline }}</h2>
        <div class="tabs-module__content tab__wrap">
            <nav class="tab__nav">
                <ul class="tab__list" role="tablist">
                    <li v-for="(tab, index) in item.Tabs" :key="index" class="tab__item" role="none" data-action="modal-tab">
                        <a :id="(`tab-item-${index}-headline`)" class="tab__headline" :href="(`#tab-item-${index}-content`)" role="tab" :aria-controls="(`#tab-item-${index}-content`)" :aria-selected="(index == 0)" tabindex="0">
                            <span class="tab__headline-inner">{{ tab.Headline }}</span>
                            <span v-if="tab.Label != ''" class="tab__headline-inner">{{ tab.Label }}</span>
                            <img :src="(`/admin/public/getimage.ashx?image=${tab.Image.PathUrlEncoded}&height=43`)" :alt="tab.Headline" class="tab__item-image" />
                        </a>
                    </li>
                </ul>
                <span class="tab__arrow">
                    <svg id="uuid-a3836ad2-cceb-4317-84a9-034b0af41477" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.936 11.122"><path d="m15.376,10.061l4.5-4.501L15.376,1.061M.75,5.561h18.001" style="stroke-width:1.5px;" /></svg>
                </span>
            </nav>
            <div v-for="(tab, index) in item.Tabs" :id="(`tab-item-${index}-content`)" :key="index" class="tab__content" role="tabpanel" :aria-hidden="(index > 0)" :aria-labelledby="(`tab-item-${index}-headline`)">
                <div class="tab__content-inner tabs-module__rich-text rich-text">
                    <text v-if="item.RichText != ''" v-html="tab.RichText"></text>
                    <img v-if="tab.Image != null & tab.Image.Path != ''" :src="tab.Image.Path" :alt="(`${tab.Headline}.`)" class="tab__image" />
                </div>
            </div>
        </div>
    </article>
</template>
<script>
import { setupTab } from '../../components/tab';
import { useItem } from '../composables/item';
const { getThemeClass } = useItem();

export default {
    name: 'Tabs',
    props: {
        item: {
            type: Object,
            default: null,
        }
    },
    mounted() {
        setupTab('[data-action="modal-tab"]');
    },
    methods: {
        getModuleThemeClass() {
            return getThemeClass(this.item);
        },
    }
};
</script>
